import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import EditableContentMultilang from './EditableContentMultilang';
import './CookieConsentBanner.css';

const COOKIE_NAME = 'site_cookie_consent';

const CookieConsentBanner = () => {
    const { currentUser } = useAuth();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = document.cookie.split('; ').find(row => row.startsWith(`${COOKIE_NAME}=`));
        
        if (!consent || currentUser) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [currentUser]);

    const setConsentCookie = (value) => {
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        document.cookie = `${COOKIE_NAME}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
        
        // Nascondi il banner sia per utenti normali che per admin
        setIsVisible(false);
    };

    const handleAccept = () => setConsentCookie('accepted');
    const handleDecline = () => setConsentCookie('declined');

    if (!isVisible) {
        return null;
    }

    const bannerClass = currentUser ? "cookie-consent-banner admin-view" : "cookie-consent-banner";

    return (
        <div className={bannerClass}>
            <div className="cookie-content">
                <div className="cookie-text">
                    <EditableContentMultilang 
                        docPath="cookie_banner/content"
                        field="message"
                        elementType="p"
                        placeholder="Utilizziamo i cookie..."
                    />
                    <Link to="/privacy-policy" className="cookie-policy-link">
                         <EditableContentMultilang 
                            docPath="cookie_banner/content"
                            field="policy_link_text"
                            elementType="span"
                            placeholder="Scopri di più"
                        />
                    </Link>
                </div>
                <div className="cookie-actions">
                    <button onClick={handleDecline} className="cookie-button decline">
                        <EditableContentMultilang 
                            docPath="cookie_banner/content"
                            field="decline_button"
                            elementType="span"
                            placeholder="Rifiuta"
                        />
                    </button>
                    <button onClick={handleAccept} className="cookie-button accept">
                         <EditableContentMultilang 
                            docPath="cookie_banner/content"
                            field="accept_button"
                            elementType="span"
                            placeholder="Accetta"
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsentBanner;